<template>
  <Modal
    data-testid="remove-confirmation-modal"
    size="md"
    title=""
    :is-open="isOpen"
    @close="emitClose"
  >
    <HelperViewStatus
      title="Deseja remover a sugestão?"
      description="Esta ação não poderá ser desfeita"
      status="alert"
    />
    <template #buttons>
      <ButtonPrimary
        class="button-primary"
        label="Remover"
        @click="emitConfirm"
      />
      <ButtonSecondary label="Voltar para a lista" @click="emitClose" />
    </template>
  </Modal>
</template>

<script setup lang="ts">
import {
  Modal,
  HelperViewStatus,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';

interface Props {
  isOpen: boolean;
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'confirm'): void;
}

defineProps<Props>();

const emit = defineEmits<EmitEvents>();

function emitClose() {
  emit('close');
}

function emitConfirm() {
  emit('confirm');
}
</script>

<style lang="less" scoped>
.helper-view {
  margin-bottom: @size-spacing-x700;
}

.button-primary {
  margin-right: @size-spacing-x300;
}
</style>
